import { useParams } from 'react-router-dom'

import { ReportDetailDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { ReportDetail } from './components/ReportDetail'
import { ReportType } from './types'

const ReportDetailPage = () => {
  const { company } = useCurrentSession()
  const { reportId } = useParams<{ reportId: string }>()
  if (!reportId) {
    throw new Error('Report ID is required')
  }

  const {
    data: reportData,
    loading,
    error,
  } = useQuery(ReportDetailDocument, {
    variables: {
      reportId: reportId,
      companyId: company.id,
    },
    skip: !reportId,
  })

  const report = reportData?.analytics.report
  if (!loading && (!report || !report.widgets[0] || !report.datasource)) {
    throw new Error('Mising datasource or widget')
  }

  const isReport = (report: null | undefined | unknown): report is ReportType => {
    return !!report && typeof report === 'object' && 'datasource' in report && 'widgets' in report
  }

  return loading || error ? (
    <ResponsivePage.Body variant="full" loading={loading} error={error}>
      &nbsp;
    </ResponsivePage.Body>
  ) : (
    report && isReport(report) && <ReportDetail report={report} />
  )
}

export default ReportDetailPage
